import type { UIStringsOverride } from "../i18n-ui.ts";

/** Russian (ru) UI strings. */
export const ru: UIStringsOverride = {
  actions: {
    addToCursor: "Добавить в Cursor",
    addToVscode: "Добавить в VS Code",
    askAI: "Спросить ИИ об этой странице",
    connectMcp: "Подключиться к MCP",
    copied: "Скопировано!",
    copyClaudeCode: "Скопировать команду Claude Code",
    copyCode: "Скопировать код",
    copyCodex: "Скопировать команду Codex",
    copyMarkdown: "Скопировать как Markdown",
    copyServerUrl: "Скопировать URL сервера",
    edit: "Редактировать на GitHub",
    export: "Экспорт",
    exportEpub: "Экспорт в EPUB",
    exportPdf: "Экспорт в PDF",
    generating: "Генерация…",
    openIn: "Открыть в {name}",
    openInChat: "Открыть в чате",
    scrollToTop: "Наверх",
  },
  ask: {
    ai: "ИИ",
    clear: "Очистить беседу",
    close: "Закрыть",
    copy: "Скопировать беседу",
    empty: "Задайте вопрос по документации.",
    error: "Извините, что-то пошло не так.",
    label: "Задать вопрос",
    placeholder: "Задайте вопрос…",
    send: "Отправить",
    tip: "Совет: чат можно открыть и закрыть с помощью",
    title: "Спросить ИИ",
    you: "Вы",
  },
  banner: { dismiss: "Закрыть объявление" },
  changelog: {
    description: "Обновления продукта и примечания к выпускам.",
    showReleases: "Показать выпуски {version}",
    title: "Журнал изменений",
  },
  content: { diagramError: "Не удалось отобразить эту диаграмму." },
  feedback: {
    no: "Нет",
    question: "Эта страница была полезной?",
    thanks: "Спасибо за ваш отзыв!",
    yes: "Да",
  },
  languageSwitcher: { label: "Язык", untranslated: "Не переведено" },
  nav: {
    back: "Назад",
    breadcrumb: "Навигационная цепочка",
    closeNavigation: "Закрыть навигацию",
    deprecated: "устарело",
    featured: "Рекомендуемое",
    githubRepository: "Репозиторий GitHub",
    navigation: "Навигация",
    primary: "Основное",
    sections: "Разделы",
    toggleNavigation: "Переключить навигацию",
    toggleTheme: "Переключить цветовую тему",
  },
  notFound: {
    description: "Не удалось найти страницу, которую вы ищете.",
    home: "Вернуться на главную",
    title: "Страница не найдена",
  },
  page: {
    lastUpdated: "Последнее обновление",
    next: "Далее",
    pagination: "Пагинация",
    previous: "Назад",
    skipToContent: "Перейти к содержимому",
  },
  search: {
    all: "Все",
    allLanguages: "Все языки",
    askAi: "Спросить ИИ",
    askAiHint: "Получите мгновенный ответ от ИИ",
    button: "Поиск",
    devOnly: "Поиск доступен в production-сборке.",
    error: "Что-то пошло не так. Попробуйте ещё раз.",
    label: "Поиск по документации",
    navigate: "навигация",
    noResults: "Ничего не найдено.",
    open: "открыть",
    placeholder: "Поиск по документации…",
    popular: "Популярное",
    preview: "предпросмотр",
    results: "Результаты",
  },
  toc: { title: "На этой странице" },
};
